import { render, staticRenderFns } from "./Servicepros.vue?vue&type=template&id=f45501bc"
import script from "./Servicepros.vue?vue&type=script&lang=js"
export * from "./Servicepros.vue?vue&type=script&lang=js"
import style0 from "./Servicepros.vue?vue&type=style&index=0&id=f45501bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports